import React, { useEffect, useState } from 'react';
import { getHomepagePromo } from '../api/homepagePromoService';
import './promoStrip.css';

const DEFAULT_CFG = {
  desktop: { placement: 'after-hero', poseSide: 'right', poseFlip: false, poseHeight: 9.5, fullWidth: true, maxWidth: 68, minHeight: 0, borderRadius: 0, padding: 1, marginY: 0, show: true },
  mobile: { placement: 'after-changeroom', poseSide: 'right', poseFlip: false, poseHeight: 7, fullWidth: true, maxWidth: 37.5, minHeight: 0, borderRadius: 0, padding: 1, marginY: 0, show: true },
};

// All admin sizes are stored AND edited in rem — render them directly.
const rem = (v) => `${Number(v) || 0}rem`;

const PromoStrip = ({ device = 'desktop', slot }) => {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    let alive = true;
    getHomepagePromo().then((p) => { if (alive) setPromo(p); });
    return () => { alive = false; };
  }, []);

  if (!promo || !promo.active || !promo.sentence || !promo.poseImageUrl) return null;

  const cfg = { ...DEFAULT_CFG[device], ...((device === 'mobile' ? promo.mobile : promo.desktop) || {}) };
  if (cfg.show === false) return null;
  if (slot && cfg.placement !== slot) return null;

  const sectionStyle = {
    width: cfg.fullWidth ? '100%' : rem(cfg.maxWidth),
    marginLeft: cfg.fullWidth ? undefined : 'auto',
    marginRight: cfg.fullWidth ? undefined : 'auto',
    marginTop: cfg.marginY ? rem(cfg.marginY) : undefined,
    marginBottom: cfg.marginY ? rem(cfg.marginY) : undefined,
    minHeight: cfg.minHeight ? rem(cfg.minHeight) : undefined,
    padding: cfg.padding != null ? rem(cfg.padding) : undefined,
    borderRadius: !cfg.fullWidth && cfg.borderRadius ? rem(cfg.borderRadius) : undefined,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
  // pose side: in RTL, default `row` puts the (first-child) pose on the right;
  // `row-reverse` flips it to the left. Pose/text widths stay the same either way.
  const innerStyle = {
    width: '100%',
    maxWidth: cfg.fullWidth ? rem(cfg.maxWidth) : '100%',
    flexDirection: cfg.poseSide === 'left' ? 'row-reverse' : 'row',
  };

  return (
    <section className="promo-strip" dir="rtl" aria-label="מבצע" style={sectionStyle}>
      {promo.backgroundImageUrl ? (
        <div
          className="promo-strip__bg"
          aria-hidden="true"
          style={{
            backgroundImage: `url(${promo.backgroundImageUrl})`,
            backgroundSize: rem(promo.backgroundTile || 11),
            opacity: promo.backgroundOpacity != null ? promo.backgroundOpacity : 0.2,
          }}
        />
      ) : null}
      <div className="promo-strip__inner" style={innerStyle}>
        {/* capped at 45% so a big pose can't squeeze the text */}
        <img className="promo-strip__pose" src={promo.poseImageUrl} alt="" aria-hidden="true" style={{ maxHeight: rem(cfg.poseHeight), maxWidth: '45%', transform: cfg.poseFlip ? 'scaleX(-1)' : undefined }} />
        <div className="promo-strip__text-wrap">
          <p className="promo-strip__text" style={{ fontSize: rem(promo.titleSize || 3), fontWeight: promo.titleWeight || 700 }}>
            {promo.sentence}
          </p>
          {promo.subtext ? (
            <p className="promo-strip__subtext" style={{ fontSize: rem(promo.subtextSize || 1.25), fontWeight: promo.subtextWeight || 400 }}>
              {promo.subtext}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default PromoStrip;
